import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "revico-community-talk-reply" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "revico-community-talk-reply--title" }, "リプライ一覧", -1 /* HOISTED */)
const _hoisted_3 = { class: "revico-community-talk-reply-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.replies, (reply, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "revico-community-talk-reply-list-item"
        }, [
          _createVNode($setup["ReplyMaster"], {
            reply: reply,
            wordSettings: $props.wordSettings,
            communityTalkStoreKey: $props.communityTalkStoreKey,
            replyPostStoreKey: $props.replyPostStoreKey
          }, null, 8 /* PROPS */, ["reply", "wordSettings", "communityTalkStoreKey", "replyPostStoreKey"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}